import React from 'react';
import '../styles/CityOrderControl.css';

type OrderControlProps<T extends string> = {
  title: string;
  order: readonly T[];
  visibleItems?: readonly T[];
  label?: (item: T) => string;
  onChange: (order: T[]) => void;
  itemAttribute?: string;
};

export function OrderControl<T extends string>({ title, order, visibleItems = order, label = item => item, onChange, itemAttribute = 'data-order-item' }: OrderControlProps<T>) {
  const visible = visibleItems;
  const move = (name: T, target: T) => {
    if (name === target) return;
    // Replace visible slots only, preserving the positions of hidden entries.
    const next = visible.filter(item => item !== name);
    next.splice(visible.indexOf(target), 0, name);
    let index = 0;
    onChange(order.map(item => visible.includes(item) ? next[index++] : item));
  };
  return <fieldset className="settings-field city-order-control">
    <legend>{title}</legend>
    <ol>
      {visible.map((name, index) => <li key={name} {...{ [itemAttribute]: name }}>
        <span>{label(name)}</span>
        <button type="button" aria-label={`Move ${label(name)} up`} disabled={index === 0}
          onClick={() => move(name, visible[index - 1])}><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 19V5m-6 6 6-6 6 6" /></svg></button>
        <button type="button" aria-label={`Move ${label(name)} down`} disabled={index === visible.length - 1}
          onClick={() => move(name, visible[index + 1])}><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 5v14m-6-6 6 6 6-6" /></svg></button>
      </li>)}
    </ol>
  </fieldset>;
}
